// extracted by mini-css-extract-plugin
module.exports = {"view":"views-Login__view--2gE8O","passwordForgot":"views-Login__passwordForgot--AX6SC"};